// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"styles_disclaimer__1O9S2","disclaimer__exclamator":"styles_disclaimer__exclamator__2TljI","disclaimer__text":"styles_disclaimer__text__tziuA"};